import React, { useEffect, useState } from 'react';
import styles from './History.module.sass';

// Seven days of flow, in the clear column beside the category counts.
//
// The counts say how big the pile is; they cannot say which way it is moving.
// A steady 530 open and a 530 that doubled on Tuesday look identical until you
// can see New against Shipped and what was left at the end of each day.
//
// Definitions and their caveats live in WorkOrderHistory (app/services) — the
// short version is that Total is exact for today and understates earlier days
// slightly, because work orders cancelled without shipping have no recorded
// close date.
const DAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// The API sends an ISO date ('2026-08-13'). Parsing that with `new Date()`
// treats it as UTC midnight and renders the PREVIOUS day for anyone west of
// Greenwich — the exact off-by-one the server side works to avoid. Split it.
const formatDate = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  const local = new Date(y, m - 1, d);
  return `${DAY[local.getDay()]} ${m}/${d}`;
};

const History = () => {
  const [rows, setRows] = useState([]);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const fetchHistory = async () => {
      try {
        const response = await fetch('/admin/work_orders/history');
        if (!response.ok) throw new Error(response.statusText);
        const body = await response.json();
        if (!cancelled) setRows(body.data || []);
      } catch (e) {
        // Say so rather than sitting empty: a blank panel reads as "no work
        // orders", which is a very different thing from "the request failed".
        if (!cancelled) setFailed(true);
      }
    };
    fetchHistory();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className={styles.panel}>
      <div className={styles.heading}>Last 7 Days</div>
      {failed && <div className={styles.message}>Could not load history</div>}
      {!failed && rows.length === 0 && <div className={styles.message}>Loading…</div>}
      {rows.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Date</th>
              <th className={styles.num} title="Open at the end of that day">Total</th>
              <th className={styles.num} title="Created that day">New</th>
              <th className={styles.num} title="Shipped that day">Shipped</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.date} className={i === 0 ? styles.today : undefined}>
                <td>{formatDate(row.date)}</td>
                <td className={styles.num}>{row.total}</td>
                <td className={styles.num}>{row.new}</td>
                <td className={styles.num}>{row.shipped}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default History;
